import styled from "styled-components"

import { useAppDispatch, useAppSelector } from "store/hooks"
import { setUserTemperatureScale } from "store/userSlise"
import { StorageKeys } from "types/enums/StorageKeys"
import TemperatureScale from "types/enums/TemperatureScale"

import { setStorageItem } from "utils/localStorage"

import { ToggleButton } from "../ToggleButton"

const TemperatureToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-muted);
`

export const TemperatureToggle = () => {
  const dispatch = useAppDispatch()
  const userTemperatureScale = useAppSelector(state => state.user.userTemperatureScale)
  const isCelsius = userTemperatureScale === TemperatureScale.CELSIUS

  const handleChange = () => {
    const scale = isCelsius ? TemperatureScale.FAHRENHEIT : TemperatureScale.CELSIUS
    setStorageItem(StorageKeys.UserTemperatureScale, scale)
    dispatch(setUserTemperatureScale(scale))
  }

  return (
    <TemperatureToggleWrapper>
      <span>°C</span>
      <ToggleButton id="temperatureToggle" name="temperatureToggle" isChecked={!isCelsius} onChange={handleChange} />
      <span>°F</span>
    </TemperatureToggleWrapper>
  )
}
